// src/components/admin/CreateClientPage.js
import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminShell } from './Sidebar';

export default function CreateClientPage() {
  const navigate = useNavigate();
  const apiBase = useMemo(() => {
    const base = process.env.REACT_APP_API_URL || '';
    return base.endsWith('/') ? base : `${base}/`;
  }, []);

  const [form, setForm] = useState({
    name: '', bin: '', phone: '', address: '', email: '', is_individual: true,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((s) => ({ ...s, [name]: type === 'checkbox' ? checked : value }));
  };

  const validate = () => {
    if (!form.name.trim()) return 'Укажите наименование клиента';
    if (!form.bin.trim()) return 'Укажите БИН/ИИН';
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return 'Некорректный e-mail';
    return '';
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const v = validate();
    if (v) return setError(v);
    setSaving(true);
    try {
      const payload = {
        name: form.name.trim(),
        bin: form.bin.trim(),
        phone: form.phone.trim(),
        address: form.address.trim(),
        email: form.email.trim(),
        is_individual: !!form.is_individual,
      };
      const res = await fetch(`${apiBase}v1/clients`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const t = await res.text().catch(() => '');
        throw new Error(`Создание клиента: HTTP ${res.status} ${t}`);
      }
      navigate('/Admin/Clients', { replace: true });
    } catch (err) {
      setError(err.message || 'Не удалось создать клиента');
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminShell
      breadcrumbs="Клиенты"
      title="Создать клиента"
      subtitle="Карточка контрагента"
      actions={
        <>
          <button type="button" className="adminbtn" onClick={() => navigate(-1)}>Отмена</button>
          <button
            type="submit"
            form="create-client-form"
            className="adminbtn adminbtn--primary"
            disabled={saving}
          >
            {saving ? 'Сохраняем…' : 'Создать клиента'}
          </button>
        </>
      }
    >
      <div className="crmpage crmpage--embedded">
        <div className="crmpage__main">
          {!!error && <div className="crmpage__alert crmpage__alert--error">{error}</div>}

          <form id="create-client-form" className="adminform" onSubmit={onSubmit} style={{ maxWidth: 880 }}>
            <section className="adminform__card">
              <div className="adminform__section-title">Реквизиты</div>
              <div className="adminform__grid">
                <label className="adminform__field adminform__field--full">
                  <span className="adminform__label">Наименование<span className="req">*</span></span>
                  <input
                    className="adminform__input"
                    name="name" value={form.name} onChange={onChange}
                    placeholder='ТОО "Ромашка"' required
                  />
                </label>
                <label className="adminform__field">
                  <span className="adminform__label">БИН/ИИН<span className="req">*</span></span>
                  <input
                    className="adminform__input"
                    name="bin" value={form.bin} onChange={onChange}
                    placeholder="123456789012" required
                  />
                </label>
                <label className="adminform__field">
                  <span className="adminform__label">Телефон</span>
                  <input
                    className="adminform__input"
                    name="phone" value={form.phone} onChange={onChange}
                    placeholder="+7 7xx xxx xx xx"
                  />
                </label>
                <label className="adminform__field">
                  <span className="adminform__label">E-mail</span>
                  <input
                    type="email"
                    className="adminform__input"
                    name="email" value={form.email} onChange={onChange}
                    placeholder="client@domain.kz"
                  />
                </label>
                <label className="adminform__field">
                  <span className="adminform__label">Адрес</span>
                  <input
                    className="adminform__input"
                    name="address" value={form.address} onChange={onChange}
                    placeholder="г. Астана, ул. ..."
                  />
                </label>
                <label className="adminform__field" style={{ flexDirection: 'row', alignItems: 'center', gap: 10, paddingTop: 28 }}>
                  <input
                    type="checkbox"
                    className="crmpage__check"
                    name="is_individual" checked={form.is_individual} onChange={onChange}
                  />
                  <span className="adminform__label" style={{ margin: 0 }}>
                    {form.is_individual ? 'Физическое лицо' : 'Юридическое лицо'}
                  </span>
                </label>
              </div>
            </section>
          </form>
        </div>
      </div>
    </AdminShell>
  );
}
